import React from 'react';
import './header.scss';

export const Header = ({ children, style }) => (
  <header style={style} className="header custom-header">
    {children}
  </header>
);
